import React from 'react';
import './quotes.css';

export default function Quotes() {
  return (
    <div className="container">
      <p className="paragraph">
        Mathematics is not about numbers, equations,
        computations or algorithms: it is about
        understanding. -William Paul Thurston
      </p>
    </div>
  );
}
